import View from './ClientLogoList.view';

export default View;
